import likeItemJsonRequest from 'owa-service/lib/factory/likeItemJsonRequest';
import likeItemRequest from 'owa-service/lib/factory/likeItemRequest';
import likeItem2Operation from 'owa-service/lib/operation/likeItem2Operation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createLikeItemRequest(itemId, isUnlike) {
    var request = likeItemRequest({
        IsUnlike: isUnlike,
        ItemId: itemId,
    });
    return request;
}
export default function likeItemService(itemId, isUnlike, requestOptions) {
    var requestBody = createLikeItemRequest(itemId, isUnlike);
    return likeItem2Operation(likeItemJsonRequest({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }), requestOptions).then(function (response) {
        var responseMessage = response.Body;
        return responseMessage;
    });
}
//# sourceMappingURL=likeItemService.js.map